import { NavLink as RouterNavLink, NavLinkProps } from "@remix-run/react";

export const disableTransitions =
  import.meta.env.VITE_DISABLE_VIEW_TRANSITIONS === "true";

export function NavLink(props: NavLinkProps) {
  return (
    <RouterNavLink unstable_viewTransition={!disableTransitions} {...props} />
  );
}
